<template>
  <div class="max-w-lg mx-auto lg:max-w-7xl px-8 xl:px-4 pt-8 pb-4">

    <div class="">
      <nav class="hidden sm:flex" aria-label="Breadcrumb">
        <ol class="flex items-center space-x-4">
          <li
            v-if="Object.keys(bcrumbs).length === 0"
            class="text-sm font-medium text-gray-500 hover:text-gray-700"
            aria-current="page"
          ></li>

          <li>
            <div>
              <router-link
                :to="{ name: 'home' }"
                class="text-gray-400 hover:text-gray-500"
              >
                <svg
                  class="flex-shrink-0 h-5 w-5"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
                  />
                </svg>
                <span class="sr-only">Home</span></router-link
              >
            </div>
          </li>

          <li
            v-for="(value, name, index) in bcrumbs"
            :key="index"
            class="text-sm font-medium text-gray-500 hover:text-gray-700"
            aria-current="page"
          >

            <div
              v-if="name == 'admin_departments_list'"
              class="flex items-center"
            >
              <svg
                class="flex-shrink-0 h-5 w-5 text-gray-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
              <router-link
                :to="{ name: 'adminDepartments' }"
                class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                >Список кафедр [adm]</router-link
              >
            </div>

            <div v-if="name == 'admin_courses_list'" class="flex items-center">
              <svg
                class="flex-shrink-0 h-5 w-5 text-gray-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
              <router-link
                :to="{ name: 'adminCourses' }"
                class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                >Список курсов</router-link
              >
            </div>

            <div v-if="name == 'admin_course'" class="flex items-center">
              <svg
                class="flex-shrink-0 h-5 w-5 text-gray-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
              <router-link
                :to="{ name: 'adminCourse_show', params: { id: value[0] } }"
                class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                >{{ value[1] }}</router-link
              >
            </div>

            <div v-if="name == 'admin_chapters_list'" class="flex items-center">
              <svg
                class="flex-shrink-0 h-5 w-5 text-gray-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
              <router-link
                :to="{
                  name: 'adminCourse_chapters',
                  params: { course_id: value },
                }"
                class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                >Список глав</router-link
              >
            </div>

            <div v-if="name == 'admin_chapter'" class="flex items-center">
              <svg
                class="flex-shrink-0 h-5 w-5 text-gray-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
              <router-link
                :to="{ name: 'adminChapter_show', params: { id: value[0] } }"
                class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                >{{ value[1] }}</router-link
              >
            </div>

            <div
              v-if="name == 'admin_questions_list'"
              class="flex items-center"
            >
              <svg
                class="flex-shrink-0 h-5 w-5 text-gray-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
              <router-link
                :to="{
                  name: 'adminChapter_questions',
                  params: { chapter_id: value },
                }"
                class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                >Список вопросов</router-link
              >
            </div>

            <div v-if="name == 'admin_question'" class="flex items-center">
              <svg
                class="flex-shrink-0 h-5 w-5 text-gray-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
              <router-link
                :to="{ name: 'adminQuestion_show', params: { id: value[0] } }"
                class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                >{{ value[1] }}</router-link
              >
            </div>

            <div v-if="name == 'admin_answers_list'" class="flex items-center">
              <svg
                class="flex-shrink-0 h-5 w-5 text-gray-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
              <router-link
                :to="{
                  name: 'adminQuestion_answers',
                  params: { question_id: value },
                }"
                class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                >Список ответов</router-link
              >
            </div>

            <div v-if="name == 'courses_list'" class="flex items-center">
              <svg
                class="flex-shrink-0 h-5 w-5 text-gray-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
              <router-link
                :to="{ name: 'courses' }"
                class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                >Курсы</router-link
              >
            </div>

            <div v-if="name == 'course'" class="flex items-center">
              <svg
                class="flex-shrink-0 h-5 w-5 text-gray-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
              <router-link
                :to="{ name: 'course_show', params: { id: value[0] } }"
                class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                >{{ value[1] }}</router-link
              >
            </div>

            <div v-if="name == 'chapter'" class="flex items-center">
              <svg
                class="flex-shrink-0 h-5 w-5 text-gray-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
              <router-link
                :to="{ name: 'chapter_show', params: { id: value[0] } }"
                class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                >{{ value[1] }}</router-link
              >
            </div>

            <div v-if="name == 'questions_list'" class="flex items-center">
              <svg
                class="flex-shrink-0 h-5 w-5 text-gray-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
              <router-link
                :to="{ name: 'questions', params: { id: value } }"
                class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                >Тестирование</router-link
              >
            </div>

            <div v-if="name == 'articles_list'" class="flex items-center">
              <svg
                class="flex-shrink-0 h-5 w-5 text-gray-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
              <router-link
                :to="{ name: 'articles' }"
                class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                >Статьи</router-link
              >
            </div>

            <div v-if="name == 'article'" class="flex items-center">
              <svg
                class="flex-shrink-0 h-5 w-5 text-gray-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
              <router-link
                :to="{ name: 'article_show', params: { id: value[0] } }"
                class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                >{{ value[1] }}</router-link
              >
            </div>

          </li>
        </ol>
      </nav>
    </div>

    <!-- <nav
      aria-label="breadcrumb"
      style="--bs-breadcrumb-divider: '>'"
      class="pt-3"
    >
      <ul class="breadcrumb" style="font-size: 80%; margin: 0">
        <li
          v-if="Object.keys(bcrumbs).length === 0"
          class="breadcrumb-item active"
          aria-current="page"
        >
          /
        </li>

        <li
          v-for="(value, name, index) in bcrumbs"
          :key="index"
          class="breadcrumb-item active"
          aria-current="page"
        >
          <router-link
            v-if="name == 'admin_departments_list'"
            :to="{ name: 'adminDepartments' }"
            >Список кафедр [adm]</router-link
          >

          <router-link
            v-if="name == 'admin_courses_list'"
            :to="{ name: 'adminCourses' }"
            >Список курсов</router-link
          >
          <router-link
            v-if="name == 'admin_course'"
            :to="{ name: 'adminCourse_show', params: { id: value[0] } }"
            >{{ value[1] }}</router-link
          >
          <router-link
            v-if="name == 'admin_chapters_list'"
            :to="{ name: 'adminCourse_chapters', params: { course_id: value } }"
            >Список глав</router-link
          >
          <router-link
            v-if="name == 'admin_chapter'"
            :to="{ name: 'adminChapter_show', params: { id: value[0] } }"
            >{{ value[1] }}</router-link
          >
          <router-link
            v-if="name == 'admin_questions_list'"
            :to="{
              name: 'adminChapter_questions',
              params: { chapter_id: value },
            }"
            >Список вопросов</router-link
          >
          <router-link
            v-if="name == 'admin_question'"
            :to="{ name: 'adminQuestion_show', params: { id: value[0] } }"
            >{{ value[1] }}</router-link
          >
          <router-link
            v-if="name == 'admin_answers_list'"
            :to="{
              name: 'adminQuestion_answers',
              params: { question_id: value },
            }"
            >Список ответов</router-link
          >

          <router-link v-if="name == 'courses_list'" :to="{ name: 'courses' }"
            >Курсы</router-link
          >
          <router-link
            v-if="name == 'course'"
            :to="{ name: 'course_show', params: { id: value[0] } }"
            >{{ value[1] }}</router-link
          >
          <router-link
            v-if="name == 'chapter'"
            :to="{ name: 'chapter_show', params: { id: value[0] } }"
            >{{ value[1] }}</router-link
          >
          <router-link
            v-if="name == 'questions_list'"
            :to="{ name: 'questions', params: { id: value } }"
            >Тестирование</router-link
          >
        </li>
      </ul>
    </nav> -->
  </div>
</template>

<script>
export default {
  props: ["bcrumbs"],
};
</script>

